import Group from 'components/utils/Group'
import HowItWorksItem from './HowItWorksItem'

interface Props {
  className?: string
  items: Array<any>
  hideContent?: boolean
}

function HowItWorksItems(props: Props) {
  const { className, items, hideContent } = props

  return <Group
    className={className}
    direction="horizontal"
    horizontalAlign="space-evenly"
    wrap="wrap"
    gap={32}
  >
    {items.map(item => <HowItWorksItem
      key={item.title}
      item={item}
      hideContent={hideContent}
    />)}
  </Group>
}

export default HowItWorksItems
